import React, { Component } from "react";
import { Bar, Line } from "react-chartjs-2";
import { CardColumns, Card, CardHeader, CardBody } from "reactstrap";
import { List } from "react-content-loader";
import AuthService from "../../../components/AuthService";
const MyListLoader = () => <List />;

const barOptions = {
  maintainAspectRatio: !0,
  responsive: !0,
  scales: {
    xAxes: [
      {
        gridLines: { display: !0 },
        scaleLabel: { display: !0, labelString: "Nbre de connnexions" }
      }
    ],
    yAxes: [
      {
        gridLines: { display: !0 },
        scaleLabel: { display: !0, labelString: "Nombre de collaborateurs" },
        ticks: {
          beginAtZero: !0,
          callback: function(value) {
            if (value % 1 === 0) {
              return value;
            }
          }
        }
      }
    ]
  }
};

const lineOptions = {
  spanGaps: true,
  responsive: true,
  maintainAspectRatio: true,
  scales: {
    xAxes: [
      {
        ticks: {
          beginAtZero: true,
          maxTicksLimit: 10,
          padding: 25,

        },
        gridLines: {
          display: true
        },
        scaleLabel: {
          display: true,
          labelString: "mois"
        }
      }
    ],
    yAxes: [
      {
        ticks: {
            beginAtZero:true,
            maxTicksLimit: 10,
            padding: 25,
            max:10,
            min:0,
            suggestedMin: 0, //min
            suggestedMax: 100, //max
        },
        gridLines: {
          display: true
        },
        scaleLabel: {
          display: true,
          labelString: "Note"
        }
      }
    ]
  },
  scaleBeginAtZero : true
};

class ChartsBienEtreRessenti extends Component {
  constructor() {
    super();
    this.Auth = new AuthService();
    this.state = {
      fetchInProgress: {
        thematicsMoi: true,
        thematicsMonEnvironnement: true,
        thematicsMesRelations: true,
        thematics: true,
        universes: true
      },
      data: {
        thematicsMoi: {},
        thematicsMonEnvironnement: {},
        thematicsMesRelations: {},
        thematics: {},
        universes: {}
      }
    };
  }

  getColors(lvlCount) {
    let colors = [lvlCount];
    let borderColors = [lvlCount];
    let r,
      g,
      b = 0;
    for (let i = 0; i < lvlCount; i++) {
      r = Math.floor(Math.random() * 256);
      g = Math.floor(Math.random() * 256);
      b = Math.floor(Math.random() * 256);
      colors[i] = "rgba(" + r + "," + g + "," + b + ", 0.4)";
      borderColors[i] = "rgba(" + r + "," + g + "," + b + ", 1)";
    }
    return { colors: colors, borderColors: borderColors };
  }

  lineChartData(thus, dataType) {
    this.Auth.httpRequest(
      "GET",
      "api/dashboard/evolution" + dataType + this.props.request
    ).then(function(datas) {


        //console.log("type de données", dataType);

        let labelsCustom = [];
        let datasetsCustom = [];
        let min = 0,
        max = 0;
        let colors = thus.getColors(Object.keys(datas.data).length);
        let k = 0;
        let finalTab = new Map();

        Object.keys(datas.data).forEach(function(key) {
            let score = [];
            let date = [];

            Object.keys(datas.data[key]).forEach(function(obj) {
            if (
                date.length != 0 &&
                datas.data[key][obj]["monthNumber"] - 1 != date[date.length - 1]
            ) {
              let diff =
              datas.data[key][obj]["weekNumber"] - date[date.length - 1];

              for (let i = 0; i <= diff; i++) {
                  score.push(null);
                  date.push(null);
              }
            }

            score.push(datas.data[key][obj]["score"]);
            date.push(datas.data[key][obj]["monthNumber"] + '/' + datas.data[key][obj]["yearNumber"]);

            if (min == 0) {
                min = datas.data[key][obj]["monthNumber"];
            }
            if (max < datas.data[key][obj]["monthNumber"]) {
                max = datas.data[key][obj]["monthNumber"];
            }
        });


    //  on assigne au label custom les dates;
        labelsCustom = date;

        datasetsCustom.push({
          label: key,
          fill: false,
          lineTension: 0.1,
          backgroundColor: colors["colors"][k],
          borderColor: colors["borderColors"][k],
          borderCapStyle: "butt",
          borderJoinStyle: "miter",
          data: score
        });

        k++;
      });

      if (dataType == "Thematics") {
        thus.Auth.httpRequest(
            "GET",
            "api/universe/selectThematics" + this.props.isAdmin ? "" : this.props.request
        ).then(
          function(datas) {
            let res = new Map();
            Object.keys(datas.data).forEach(function(i) {
              let thematic = datas.data[i].thematic;
              let universe = datas.data[i].universe;
              Object.keys(datasetsCustom).forEach(function(key) {
                if (thematic == datasetsCustom[key]["label"]) {
                  if (!res.has(universe) || res.get(universe) == null) {
                    res.set(universe, new Array(datasetsCustom[key]));
                  } else {
                    let temp = res.get(universe);
                    temp.push(datasetsCustom[key]);
                    res.set(universe, temp);
                  }
                }
              });
            });

            thus.setState(function(state, props) {
              let fetch = state.fetchInProgress;
              let data = state.data;
              fetch.thematics = false;
              data.thematics = {
                labels: Array.apply(null, { length: max + 1 })
                  .map(Number.call, Number)
                  .slice(min),
                datasets: res
              };
              return {
                fetchInProgress: fetch,
                data: data
              };
            });
          }
        );
      }     else {
        thus.setState(function(state, props) {
          let fetch = state.fetchInProgress;
          let data = state.data;
          switch (dataType) {
            case "Universes":
              fetch.universes = false;
              data.universes = {
                  labels: labelsCustom,
                  datasets: datasetsCustom
              };
              break;
            case "ThematicsFromUniverseMoi":
              fetch.thematicsMoi = false;
              data.thematicsMoi = {
                  labels: labelsCustom,
                  datasets: datasetsCustom
              };
              break;
            case "ThematicsFromUniverseMonEnvironnement":
              fetch.thematicsMonEnvironnement = false;
              data.thematicsMonEnvironnement = {
                  labels: labelsCustom,
                  datasets: datasetsCustom
              };
              break;
            case "ThematicsFromUniverseMesRelations":
                //console.log("data set à faire afficher", datasetsCustom);
              fetch.thematicsMesRelations = false;
              data.thematicsMesRelations = {
                labels: labelsCustom,
                datasets: datasetsCustom
              };
          }
          return {
            fetchInProgress: fetch,
            data: data
          };
        });
      }
    }).catch(error => {
        if (!thus.props.isAdmin && !thus.props.error) {
            thus.props.notifyError();
        }
    });
  }

  barChartData(thus, dataType) {
    this.Auth.httpRequest(
      "GET",
      "api/dashboard/" + dataType + this.props.request
    ).then(function(datas) {
      let labelCustom = [],
        dataCustom = [];
      Object.keys(datas.data).forEach(function(key) {
        labelCustom.push(datas.data[key].label);
        dataCustom.push(datas.data[key].data);
      });

      let dataSetsCustom = [
        {
          label: "",
          backgroundColor: "rgba(90,61,145,0.2)",
          borderColor: "rgba(90,61,145,1)",
          borderWidth: 1,
          hoverBackgroundColor: "rgba(90,61,145,0.4)",
          hoverBorderColor: "rgba(90,61,145,1)",
          data: dataCustom
        }
      ];

      thus.setState(function(state, props) {
        let fetch = state.fetchInProgress;
        let data = state.data;
        switch (dataType) {
          case "numberOfUseByNumberOfUsers":
            fetch.numberOfUseByNumberOfUsers = false;
            data.numberOfUseByNumberOfUsers = {
              labels: labelCustom,
              datasets: dataSetsCustom
            };
            break;

          case "durationByNumberOfUsers":
            fetch.durationByNumberOfUsers = false;
            data.durationByNumberOfUsers = {
              labels: labelCustom,
              datasets: dataSetsCustom
            };
            break;

          case "numberOfShareByNumberOfUsers":
            fetch.numberOfShareByNumberOfUsers = false;
            data.numberOfShareByNumberOfUsers = {
              labels: labelCustom,
              datasets: dataSetsCustom
            };
            break;

          case "numberOfSuperSmilesByNumberOfUsers":
            fetch.numberOfSuperSmilesByNumberOfUsers = false;
            data.numberOfSuperSmilesByNumberOfUsers = {
              labels: labelCustom,
              datasets: dataSetsCustom
            };
            break;

          case "levelByNumberOfUsers":
            fetch.levelByNumberOfUsers = false;
            data.levelByNumberOfUsers = {
              labels: labelCustom,
              datasets: dataSetsCustom
            };
            break;

          case "gameDoneByDay":
            fetch.gameDoneByDay = false;
            data.gameDoneByDay = {
              labels: labelCustom,
              datasets: dataSetsCustom
            };
            break;
        }
        return {
          fetchInProgress: fetch,
          data: data
        };
      });
    }).catch(error => {
        if (!thus.props.isAdmin && !thus.props.error) {
            thus.props.notifyError();
        }
    });
  }

  fetchAllData() {
    //this.lineChartData(this, 'Thematics');
    this.lineChartData(this, "ThematicsFromUniverseMoi");
    this.lineChartData(this, "ThematicsFromUniverseMesRelations");
    this.lineChartData(this, "ThematicsFromUniverseMonEnvironnement");
    this.lineChartData(this, "Universes");
  }

  componentDidUpdate(prevProps) {
    if (prevProps.newFetch !== this.props.newFetch) {
      this.fetchAllData();
    }
  }

  componentDidMount() {
    this.fetchAllData();
  }

  render() {
    let contentTh,
      contentUn,
      contentThMoi,
      contentThMesRelations,
      contentThMonEnvironnement;
    if (this.state.fetchInProgress.thematics) {
      contentTh = <List />;
    } else {
      contentTh = new Array();
      var lab = this.state.data.thematics.labels;
      this.state.data.thematics.datasets.forEach(function(item, key, mapObj) {
        var obj = { datasets: item, labels: lab };
        contentTh.push(
          <div key={key} className="chart-wrapper">
            {key}
            <Line data={obj} options={lineOptions} />
          </div>
        );
      });
    }
    if (this.state.fetchInProgress.universes) {
      contentUn = <List />;
    } else {
      contentUn = (
        <div className="chart-wrapper">
          <Line data={this.state.data.universes} options={lineOptions} />
        </div>
      );
    }
    if (this.state.fetchInProgress.thematicsMoi) {
      contentThMoi = <List />;
    } else {
      contentThMoi = (
        <div className="chart-wrapper">
          <Line data={this.state.data.thematicsMoi} options={lineOptions} />
        </div>
      );
    }
    if (this.state.fetchInProgress.thematicsMonEnvironnement) {
      contentThMonEnvironnement = <List />;
    } else {
      contentThMonEnvironnement = (
        <div className="chart-wrapper">
          <Line
            data={this.state.data.thematicsMonEnvironnement}
            options={lineOptions}
          />
        </div>
      );
    }
    if (this.state.fetchInProgress.thematicsMesRelations) {
      contentThMesRelations = <List />;
    } else {
      contentThMesRelations = (
        <div className="chart-wrapper">
          <Line
            data={this.state.data.thematicsMesRelations}
            options={lineOptions}
          />
        </div>
      );
    }


    return (
      <React.Fragment>
        <CardColumns className="cols-2">
          <Card>
            <CardHeader>
              Évolution des thématiques de l'Univers Moi
              <div className="card-actions" />
            </CardHeader>
            <CardBody>{contentThMoi}</CardBody>
          </Card>
          <Card>
            <CardHeader>
              Évolution des thématiques de l'Univers Mon Environnement
              <div className="card-actions" />
            </CardHeader>
            <CardBody>{contentThMonEnvironnement}</CardBody>
          </Card>
        </CardColumns>
        <CardColumns className="cols-2">
          <Card>
            <CardHeader>
              Évolution des thématiques de l'Univers Mes Relations
              <div className="card-actions" />
            </CardHeader>
            <CardBody>{contentThMesRelations}</CardBody>
          </Card>
          <Card>
            <CardHeader>
              Évolution des univers
              <div className="card-actions" />
            </CardHeader>
            <CardBody>{contentUn}</CardBody>
          </Card>
        </CardColumns>

      </React.Fragment>
    );
  }
}

export default ChartsBienEtreRessenti;



// WEBPACK FOOTER //
// ./src/views/Base/ChartsBienEtreRessenti/ChartsBienEtreRessenti.js